// Photo filenames for Family Jamming 2004
const FAMILY_JAMMING_2004_PHOTOS = [
  'fj001jpg_51858385924_z.jpg',
  'fj002jpg_51858386034_z.jpg',
  'fj003jpg_51857098052_z.jpg',
  'fj005jpg_51857098027_z.jpg',
  'fj009jpg_51858712250_z.jpg',
  'fj011jpg_51858137178_z.jpg',
  'fj012jpg_51858137163_z.jpg',
  'fj013jpg_51857097987_z.jpg',
  'fj015jpg_51857097967_l.jpg',
  'fj019_51858050476_z.jpg',
  'fj022_51858137138_z.jpg',
];

export default FAMILY_JAMMING_2004_PHOTOS;
